import NetworkError from "../../components/NetworkError";
import Preloader from "../../components/Preloader";
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useParams } from "react-router-dom";
import { useContext, useState } from "react";
import { config } from "../../constants/config";
import { useEffect } from "react";
import UserContext from "../../contexts/UserContext";
import UserInfos from "../../components/users/userinfos";
import AccountsUser from "../../components/accounts/accountusers";



export default function ViewUser() {
    // states
    let codeuser = useParams();
    const { user, logoutUser } = useContext(UserContext);
    const [page, setPage] = useState(0);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [nom, setNom] = useState("");
    const [email, setEmail] = useState("");


    const getUtilisateur = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        // var urlencoded = new URLSearchParams();
        // urlencoded.append("cpte", user.code);
        // urlencoded.append("prof", user.profil);
        // urlencoded.append("conn", user.token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users/${codeuser.code}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let body = data?.body?.data[0];

                        setNom(body?.nom !== null ? body?.nom : "");
                        setEmail(body?.email ? body?.email : null);

                        setLoading(false);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        })
            .catch((err) => {
                // console.log("error", err);
                setError(true);
                setLoading(false);
            });
    }


    const displayPages = () => {
        if (page === 0) {
            return <UserInfos codeuser={codeuser.code} />;
        } else {
            return <AccountsUser codeuser={codeuser.code} nameuser={nom} email={email} />;
        }
        // else {
        //     return <EmployeeScans refid={refId} code={codeemploye.code}  />;
        // }
    }


    // comportements
    useEffect(() => {
        getUtilisateur();
    }, []);



    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="container-fluid">
                <h1 className="h4 mb-2 font-weight-bold text_primary">Users</h1>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", justifyItems: "center" }}>
                    <button onClick={() => { setPage(0) }} className={`btn-shadow rounded-0 btn ${page === 0 ? 'btn-primary' : 'btn-secondary'}`}>
                        <span>User's informations</span>
                    </button>
                    <button onClick={() => { setPage(1) }} className={`btn-shadow rounded-0 btn ${page === 1 ? 'btn-primary' : 'btn-secondary'}`}>
                        <span>User's accounts</span>
                    </button>
                </div>
                {displayPages()}
            </div>}
        </>
    )
}